export const services = [
  {
    id: 1,
    icon: 'ri-code-box-line',
    title: 'Custom Software Development',
    description: 'End-to-end development of bespoke software tailored to your business needs, from architecture to deployment.',
  },
  {
    id: 2,
    icon: 'ri-lightbulb-line',
    title: 'IT Consulting',
    description: 'Strategic technology advice to optimize processes, select the right tools, and make informed decisions.',
  },
  {
    id: 3,
    icon: 'ri-line-chart-line',
    title: 'Digital Marketing',
    description: 'Brand growth strategies, audience targeting, and marketing campaigns that drive measurable results.',
  },
  {
    id: 4,
    icon: 'ri-palette-line',
    title: 'UI/UX Design',
    description: 'User-centered interface and experience design that combines aesthetics with usability for maximum impact.',
  },
  {
    id: 5,
    icon: 'ri-smartphone-line',
    title: 'Mobile App Development',
    description: 'Native and cross-platform mobile applications for iOS and Android, built with performance and user experience in mind.',
  },
  {
    id: 6,
    icon: 'ri-shield-check-line',
    title: 'QA & Support',
    description: 'Comprehensive testing and ongoing maintenance ensuring your products perform flawlessly at all times.',
  },
];